// Check if process.env exists (for Webpack)
const isWebpack = typeof process !== "undefined" && typeof process.env !== "undefined";

export const Env = {
  // eslint-disable-next-line
  // @ts-ignore
  PUBLIC_BACKEND_URL: isWebpack ? process.env.PUBLIC_BACKEND_URL : typeof import.meta.env !== "undefined" ? import.meta.env.PUBLIC_BACKEND_URL : undefined,
};
